import Nav from './Nav.component';

export default Nav;
